import type React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';

const imagesSet1 = [{
  src: '/images/login/1.png',
  alt: 'brand1',
  width: 148,
  height: 32,
  className: 'invert-100'
}, {
  src: '/images/login/2.png',
  alt: 'brand2',
  width: 148,
  height: 32,
  className: 'invert-100'
}, {
  src: '/images/login/3.png',
  alt: 'brand3',
  width: 148,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/4.png',
  alt: 'brand4',
  width: 148,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/5.png',
  alt: 'brand5',
  width: 148,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/6.png',
  alt: 'brand6',
  width: 98,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/7.svg',
  alt: 'brand7',
  width: 87,
  height: 24,
  className: 'invert-100 h-[24px]!'
},
{
  src: '/images/login/8.svg',
  alt: 'brand8',
  width: 187,
  height: 24,
  className: 'invert-100 h-[24px]!'
},
{
  src: '/images/login/9.png',
  alt: 'brand9',
  width: 112,
  height: 24,
  className: 'invert-100 h-[24px]!'
},
{
  src: '/images/login/10.svg',
  alt: 'brand10',
  width: 115,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/11.png',
  alt: 'brand11',
  width: 148,
  height: 32,
  className: 'invert-100'
},
{
  src: '/images/login/12.png',
  alt: 'brand12',
  width: 112,
  height: 24,
  className: 'invert-100 h-[24px]!'
}];

const imagesSet2 = [
  {
    src: '/images/login/13.svg',
    alt: 'brand13',
    width: 106,
    height: 32,
    className: 'invert-100'
  },
  {
    src: '/images/login/14.svg',
    alt: 'brand14',
    width: 148,
    height: 24,
    className: 'invert-100 h-[24px]!'
  },
  {
    src: '/images/login/15.svg',
    alt: 'brand15',
    width: 88,
    height: 32,
    className: 'invert-100'
  },
  {
    src: '/images/login/16.svg',
    alt: 'brand16',
    width: 94,
    height: 32,
    className: 'invert-100'
  },
  {
    src: '/images/login/17.svg',
    alt: 'brand17',
    width: 169,
    height: 24,
    className: 'invert-100 h-[24px]!'
  },
  {
    src: '/images/login/18.png',
    alt: 'brand18',
    width: 65,
    height: 24,
    className: 'h-[24px]!'
  },
  {
    src: '/images/login/19.png',
    alt: 'brand19',
    width: 32,
    height: 32,
    className: 'invert-100'
  },
  {
    src: '/images/login/20.png',
    alt: 'brand20',
    width: 122,
    height: 32,
  },
  {
    src: '/images/login/21.svg',
    alt: 'brand21',
    width: 77,
    height: 24,
    className: 'invert-100 h-[24px]!'
  },
  {
    src: '/images/login/22.png',
    alt: 'brand22',
    width: 32,
    height: 32,
  },
  {
    src: '/images/login/23.png',
    alt: 'brand23',
    width: 38,
    height: 32,
  },
  {
    src: '/images/login/24.png',
    alt: 'brand24',
    width: 70,
    height: 32,
  }];

export const ImageSlider = () => {
  return (
    <div className='w-full flex flex-col gap-8'>
      <Slider
        dots={false}
        infinite={true}
        speed={6500}
        autoplaySpeed={0}
        slidesToShow={4}
        slidesToScroll={1}
        autoplay={true}
        arrows={false}
        cssEase='linear'
        rtl={true}
      >
        {imagesSet1.map((image, index) => (
          <div key={index} className="flex items-center justify-center">
            <Image
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              className={`object-contain w-auto h-[32px] ${image.className}`}
            />
          </div>
        ))}
      </Slider>
      <Slider
        rtl={false}
        dots={false}
        infinite={true}
        speed={6500}
        autoplaySpeed={0}
        slidesToShow={4}
        slidesToScroll={1}
        autoplay={true}
        arrows={false}
        cssEase='linear'
      >
        {imagesSet2.map((image, index) => (
          <div key={index} className="flex items-center justify-center">
            <Image
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              className={`object-contain w-auto h-[32px] ${image.className}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
